import 'css-chunksrc/client/scenes/projectResourceEdition/form/styles.scss';export default {
  "label": "_label_1cgd0_1"
};